var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#898EA2",
    stroke: "#898EA2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5V4.25H3.20718L3.25115 5.0416L4 5ZM12 5L12.7488 5.0416L12.7928 4.25H12V5ZM4 5.75H12V4.25H4V5.75ZM11.2512 4.9584L10.8561 12.0693L12.3538 12.1525L12.7488 5.0416L11.2512 4.9584ZM9.60803 13.25H6.39197V14.75H9.60803V13.25ZM5.1439 12.0693L4.74885 4.9584L3.25115 5.0416L3.64621 12.1525L5.1439 12.0693ZM6.39197 13.25C5.72856 13.25 5.1807 12.7317 5.1439 12.0693L3.64621 12.1525C3.72717 13.6098 4.93246 14.75 6.39197 14.75V13.25ZM10.8561 12.0693C10.8193 12.7317 10.2714 13.25 9.60803 13.25V14.75C11.0675 14.75 12.2728 13.6098 12.3538 12.1525L10.8561 12.0693Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 4,
    height: 3,
    fill: "none",
    rx: 1,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 5H13",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.fcafd292cc7d13e194a888f1b4c889a2.svg";
export { ForwardRef as ReactComponent };